import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Spinner } from '@chakra-ui/react';
import axiosInstance from './../services/axiosInstance';
import useVideoTracking from './../../hooks/useVideoTracking';

const VideoPlayer = ({ idvdocipher, videoId, video }) => {
  const [otp, setOtp] = useState('');
  const playerRef = useRef(null);
  const [playbackInfo, setPlaybackInfo] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVdo = async () => {
      setLoading(true);
      setError('');

      if (idvdocipher) {
        try {
          const response = await axiosInstance.get(`/vdocipher/${idvdocipher}`);
          const { otp, playbackInfo } = response.data;
          setOtp(otp);
          setPlaybackInfo(playbackInfo);
        } catch (err) {
          console.error('خطأ في جلب OTP ومعلومات التشغيل:', err);
          setError("فشل تحميل الفيديو. الرجاء المحاولة مرة أخرى لاحقًا.");
        }
      } else {
        setError("معرف الفيديو غير موجود.");
      }

      setLoading(false);
    };

    fetchVdo();
  }, [idvdocipher]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="360px" dir="rtl">
        <Spinner size="xl" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="360px" dir="rtl">
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  return (
    <Box width="100%" height={450} mx="auto" dir="rtl">
      {otp && playbackInfo && (
        <iframe
          border={"2px black solid"}
          width="100%"
          height="100%"
          src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
          allow="encrypted-media"
          allowFullScreen
          frameBorder="0"
          ref={playerRef}
        ></iframe>
      )}
    </Box>
  );
};

VideoPlayer.propTypes = {
  video: PropTypes.object,
  idvdocipher: PropTypes.string,
  videoId: PropTypes.string
};

export default VideoPlayer;


